import { render, staticRenderFns } from "./CompetitionView.vue?vue&type=template&id=1b4828da"
import script from "./CompetitionView.vue?vue&type=script&lang=js"
export * from "./CompetitionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports